import { Dayjs } from "dayjs";
import BirthDayNavigation from "./BirthDayNavigation";
import CalenDarMonth from "./CalendarMonth";
import CalendarWeeks from "./CalendarWeeks";
import { CalendarDayProps } from "./CalendarDay";
import { useState } from "react";

interface BirthDayCalendarProps {
	minDate: Dayjs;
	maxDate: Dayjs;
	value: Dayjs;
	formatter?: (item: CalendarDayProps) => CalendarDayProps;
	onChange: (val?: Dayjs) => void;
}

export default function BirthDayCalendar(props: BirthDayCalendarProps) {
	const [activeMonth, setActiveMonth] = useState(() => {
		return props.value;
	});

	return (
		<div className="w-[340px]">
			<BirthDayNavigation
				minDate={props.minDate}
				maxDate={props.maxDate}
				onNext={(val) => setActiveMonth(val)}
				date={activeMonth}
			/>
			<CalendarWeeks />
			<CalenDarMonth
				value={props.value}
				monthDateValue={activeMonth}
				onChange={(val) => {
					val && props.onChange(val);
				}}
				formatter={props.formatter}
			/>
		</div>
	);
}
